import { Popup } from 'common-components'
import { MOBILE_SIZE_BREAKPOINT, TABLET_SIZE_BREAKPOINT } from 'consts'
import { COLORS } from 'consts/colors'
import styled, { css } from 'styled-components'
import { disableSomeContentStyles } from 'styles/mixins'
import { GRADIENTS, RADII } from 'styles/consts'

const _gradientStyles = css`
  background: ${GRADIENTS.premium};
  &:hover {
    background: ${GRADIENTS.premiumHover};
  }
`

const _defaultStyles = css`
  @media (min-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    &:hover {
      background-color: ${COLORS.fill};
      p {
        color: ${COLORS.secondaryDark};
      }
      svg {
        path {
          fill: ${COLORS.secondaryDark};
        }
      }
    }
  }
`

export const AnimateButton = styled.div<{
  $disabled: boolean
  $hasGradientBackground: boolean
}>`
  @media screen and (max-width: ${TABLET_SIZE_BREAKPOINT}px) {
    width: 32px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    &:hover {
      background: ${({ $disabled }) => ($disabled ? 'none' : COLORS.fill)};
    }
  }

  @media screen and (min-width: ${TABLET_SIZE_BREAKPOINT + 1}px) {
    padding: 4px 12px;
    height: 24px;
    width: auto;
    border-radius: ${RADII.field};
    border: 1px solid ${COLORS.borderColor};
    background-color: ${COLORS.white};

    display: flex;
    align-items: center;
    gap: 8px;

    ${({ $hasGradientBackground }) =>
      $hasGradientBackground ? _gradientStyles : _defaultStyles}
  }
  border-radius: ${RADII.field};
  cursor: pointer;
  ${({ $disabled }) => $disabled && disableSomeContentStyles(0.5)}
`

export const IconWithText = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
`

export const MobilePopupContainer = styled(Popup)`
  .popup-content {
    width: 100%;
    max-width: 356px;
    padding: 50px 20px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
`

export const MobilePopupContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
`

export const IconWrapper = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 52px;
  height: 52px;
  border-radius: ${RADII.card};
  background-color: ${COLORS.primaryTint};
`
export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 8px;

  .highlighted {
    color: ${COLORS.secondarySemiDark};
    font-weight: 600;
  }
`

export const ButtonsWrapper = styled.div<{
  $hasGradientBackground: boolean
}>`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  .button {
    min-width: max-content;
    padding: 8px 12px;
  }

  .animate {
    ${({ $hasGradientBackground }) => $hasGradientBackground && _gradientStyles}
  }
`
